export default __webpack_public_path__ + "static/dla_faces_alive_03-506e26ca2dd8a9f2e31b6045fc9d6d78.gif";